import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import SVG from './../SVG'
import { ALLOW_ACTION_BUTTON_TEXT } from '../../constants'

import './Dropdown.scss'

export const Dropdown = ({
  icon = null,
  children,
  id,
  content = null,
  open = false,
  mainClass,
  ariaLabel,
  title
}) => {
  const [haveChildrenCount, setChildrenCount]=useState(false)
  const [isActive, setValue] = useState(open)
  const isMounted = useRef(false)
  const containerRef = useRef(null)
  const triggerRef = useRef(null)

  const toggleDropdown = shouldClose => {
    const isDropdownActive = shouldClose === 'true' ? false : !isActive
    isMounted.current && setValue(isDropdownActive)
  }

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    const handleDocumentClick = event => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setValue(false)
      }
      const innerHTMLValue = (event.target.innerHTML || '')
        .replace(/<\/?span[^>]*>/g,'')
      if (ALLOW_ACTION_BUTTON_TEXT.includes(innerHTMLValue.toUpperCase())) {
        setValue(false)
      }
    }
    document.addEventListener('click', handleDocumentClick)
    return () => document.removeEventListener('click', handleDocumentClick)
  }, [])

  useEffect(() => {
    const handleDocumentKeyDown = event => {
      if (event.key === 'Escape' && isActive) {
        event.preventDefault()
        setValue(false)
        triggerRef.current && triggerRef.current.focus()
      }
    }
    document.addEventListener('keydown', handleDocumentKeyDown)
    return () => document.removeEventListener('keydown', handleDocumentKeyDown)
  }, [isActive])

  const handleContentClick = event => {
    const item = event.target.closest && event.target.closest('button, a')
    if (
      item &&
      !item.disabled &&
      !item.closest('[data-dropdown-keep-open]')
    ) {
      setValue(false)
      triggerRef.current && triggerRef.current.focus()
    }
  }

  useEffect(() => {
    setChildrenCount(children.ref?.current?.childElementCount!==0?true:false)
  }, [children])
  
  const menuId =
    id && String(id).trim()
      ? `${String(id).trim().replace(/\s+/g, '-')}-dropdown-menu`
      : undefined

  return (
    <div
      ref={containerRef}
      id={id}
      className={`dropdown ${mainClass} is-right ${isActive ? 'is-active' : ''}`}
    >
      {haveChildrenCount && <button
        type="button"
        ref={triggerRef}
        className="button is-icon-button dropdown-trigger"
        onClick={toggleDropdown}
        aria-label={ariaLabel}
        aria-expanded={isActive}
        aria-controls={menuId}
        title={title}
      >
        {icon && (
          <SVG height={24} width={24}>
            {icon}
          </SVG>
        )}
        {content}
      </button>}
      <div className="dropdown-menu" id={menuId}>
        <div className="dropdown-content" onClick={handleContentClick}>
          {children}
        </div>
      </div>
    </div>
  )
}

Dropdown.propTypes = {
  icon: PropTypes.node,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  content: PropTypes.node,
  open: PropTypes.bool,
  mainClass: PropTypes.string,
  ariaLabel: PropTypes.string,
  title: PropTypes.string
}

Dropdown.defaultProps = {
  id: '',
  content: null,
  open: false,
  mainClass:'',
  ariaLabel: undefined,
  title: undefined
}

export default Dropdown
